import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "../base/private/privateBaseQuery";

export interface DeleteAttemptResponse {
  status: string;
  status_code: string;
  message: string;
  deleted: {
    attempt_id: number;
    assignment_id: number;
    student_id: number;
  };
}

export interface CreateAttemptResponse {
  status: string;
  status_code: string;
  entity: {
    id: number;
    assignment_id: number;
    student_id: number;
    status: string;
    created_at: string;
  };
}

export const managerApi = createApi({
  reducerPath: "managerApi",
  baseQuery: privateBaseQuery(),
  endpoints: (builder) => ({
    deleteAttempt: builder.mutation<DeleteAttemptResponse, { attemptId: number }>({
      query: ({ attemptId }) => ({
        url: `/assignment/attempts/${attemptId}.json`,
        method: "DELETE",
      }),
    }),
    createAttempt: builder.mutation<CreateAttemptResponse, { assignmentId: number; studentId: number }>({
      query: ({ assignmentId, studentId }) => ({
        url: `/assignment/attempts/${assignmentId}/store.json`,
        method: "POST",
        body: { student_id: studentId },
      }),
    }),
  }),
});

export const {
  useDeleteAttemptMutation,
  useCreateAttemptMutation,
} = managerApi;
